import { ReactComponent as BackIcon } from "@/Images/icons/back.svg"
import { cn } from "@/utils"
import clsx from "clsx"
import { Fragment, HTMLAttributes, ReactNode, useMemo } from "react"
import { NavLink } from "react-router-dom"
import "./style.sass"

type ButtonVariant = "contained" | "outlined"
type ButtonColor = "primary" | "success" | "inherit" | "error" | "secondary"

interface ButtonProps extends HTMLAttributes<HTMLButtonElement | Omit<HTMLAnchorElement, "href" | "alt">> {
  color?: ButtonColor
  variant?: ButtonVariant
  leftIcon?: ReactNode
  rightIcon?: ReactNode
  loading?: boolean
  size?: "sm" | "md"
  to?: string
  disabled?: boolean
  type?: string
  back?: boolean
  activeClassName?: string
}
export const Button = ({
  back,
  leftIcon,
  rightIcon,
  color = "primary",
  variant = "contained",
  children,
  loading,
  size,
  to,
  activeClassName,
  ...props
}: ButtonProps) => {
  const className = useMemo(
    () =>
      cn(
        "button-base custom-button duration-100 bg-second font-bold flex justify-center items-center px-[20px] text-[14px] min-w-[120px]",
        `button-${variant}__${color}`,
        size === "sm" ? "min-h-[30px]" : "min-h-[40px]",
        props.className,
      ),
    [color, variant, size, props.className],
  )
  if (to != null)
    return (
      <NavLink {...props} className={clsx(className, props.className)} to={to}>
        {!loading ? (
          <Fragment>
            {back ? <BackIcon className="mr-2" /> : leftIcon}
            {children}
            {rightIcon}
          </Fragment>
        ) : (
          <span>Loading...</span>
        )}
      </NavLink>
    )
  return (
    <button
      disabled={loading || props.disabled}
      {...(props as HTMLAttributes<HTMLButtonElement>)}
      className={cn(className, "relative duration-75", props.className)}
    >
      {!loading ? (
        <Fragment>
          {back ? <BackIcon className="mr-2" /> : leftIcon}
          {children}
          {rightIcon}
        </Fragment>
      ) : (
        <span>Loading...</span>
      )}
    </button>
  )
}
